import { postFetch } from '../fetch';
import { apiConfig } from '../config';

import { Attempt } from '../../../typings';

export function postRunCode<T>(params: {
    problemId: number;
    markers: { user_answer: string };
}): Promise<{ attempt: Attempt<T> }> {
    const { apiPostRunCode } = apiConfig.getStaticUrls();

    return postFetch(apiPostRunCode, params);
}
